var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-root l-canvas titlebar_none",class:_vm.selector,attrs:{"id":"app"}},[_c('TheHeader'),_c('div',{staticClass:"l-main"},[_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""},on:{"before-enter":_vm.onEnter}},[_c('router-view',{staticClass:"l-main-h i-cf"})],1)],1),_c('TheFooter'),_c('TheSvgList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }